import React, { useState, useEffect } from 'react';
import './PlayerComparison.css';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';

function PlayerComparison({ players = [] }) {
    // Set initial state to Boris and Steven if available
    const [player1, setPlayer1] = useState(null);
    const [player2, setPlayer2] = useState(null);

    // When players are loaded, set Boris and Steven as default
    useEffect(() => {
        const getPlayerByName = (name) => players.find(p => p.Spieler === name) || null;
        setPlayer1(getPlayerByName('Boris'));
        setPlayer2(getPlayerByName('Steven'));
    }, [players]);

    const handleSelectPlayer = (event, setPlayer) => {
        const selectedPlayerName = event.target.value;
        const selectedPlayer = players.find(player => player.Spieler === selectedPlayerName);
        setPlayer(selectedPlayer || null);
    };

    const statKeysBarChart = [
        'Kurzfristiger\nScore\n(Letzten3)',
        'Mittelfristiger\nScore\n(Letzten10)',
        'Langfristiger\nScore\n(Allzeit)',
    ];

    const statKeysPieChart = [
        { key: 'Siege', label: 'Wins' },
        { key: 'Niederlagen', label: 'Losses' }
    ];

    // Use blue for wins, red for losses
    const PIE_COLORS = ['#1e90ff', '#F44336'];

    const chartData = statKeysBarChart.map(key => ({
        name: key,
        [player1?.Spieler || 'Player 1']: parseFloat(player1?.[key]) || 0,
        [player2?.Spieler || 'Player 2']: parseFloat(player2?.[key]) || 0,
    }));

    function getPieData(player) {
        if (!player) return [];
        return statKeysPieChart.map(stat => ({
            name: stat.label,
            value: parseInt(player[stat.key], 10) || 0
        }));
    }

    return (
        <div className="player-comparison">
            <h2>Player Comparison</h2>
            <div className="comparison-selectors">
                <div>
                    <label htmlFor="player1">Select Player 1:</label>
                    <select
                        id="player1"
                        value={player1?.Spieler || ''}
                        onChange={(e) => handleSelectPlayer(e, setPlayer1)}
                    >
                        <option value="">--Select--</option>
                        {players.map((player, index) => (
                            <option key={index} value={player.Spieler || ''}>
                                {player.Spieler || 'Unknown Player'}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="player2">Select Player 2:</label>
                    <select
                        id="player2"
                        value={player2?.Spieler || ''}
                        onChange={(e) => handleSelectPlayer(e, setPlayer2)}
                    >
                        <option value="">--Select--</option>
                        {players.map((player, index) => (
                            <option key={index} value={player.Spieler || ''}>
                                {player.Spieler || 'Unknown Player'}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            {player1 && player2 && (
                <>
                    <div className="comparison-table">
                        <table>
                            <thead>
                            <tr>
                                <th>Statistic</th>
                                <th>{player1.Spieler}</th>
                                <th>{player2.Spieler}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {Object.keys(player1).map((key) => (
                                key !== "Spieler" && (
                                    <tr key={key}>
                                        <td>{key}</td>
                                        <td>{player1[key]}</td>
                                        <td>{player2[key]}</td>
                                    </tr>
                                )
                            ))}
                            </tbody>
                        </table>
                    </div>
                    <div style={{ width: '100%', height: 300, marginTop: 30 }}>
                        <ResponsiveContainer>
                            <BarChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
                                <XAxis dataKey="name" tick={{ fontSize: 14 }} />
                                <YAxis tick={{ fontSize: 14 }} />
                                <Tooltip contentStyle={{ fontSize: 14 }} />
                                <Legend wrapperStyle={{ fontSize: 14 }} />
                                <Bar dataKey={player1.Spieler} fill="#4CAF50" barSize={30} />
                                <Bar dataKey={player2.Spieler} fill="#FF5722" barSize={30} />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 30 }}>
                        {[player1, player2].map((player, idx) => (
                            <div key={idx} style={{ width: '45%', textAlign: 'center' }}>
                                <h4>{player?.Spieler}</h4>
                                <ResponsiveContainer width="100%" height={250}>
                                    <PieChart>
                                        <Pie
                                            data={getPieData(player)}
                                            dataKey="value"
                                            nameKey="name"
                                            cx="50%"
                                            cy="50%"
                                            outerRadius={80}
                                            label
                                        >
                                            {getPieData(player).map((entry, i) => (
                                                <Cell key={`cell-${i}`} fill={PIE_COLORS[i % PIE_COLORS.length]} />
                                            ))}
                                        </Pie>
                                        <Tooltip />
                                        <Legend />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
}

export default PlayerComparison;